import { useContext } from 'react';
import { TitleContext } from 'contexts/TitleContext';

export default function useTitle() {
  const { menuItems, setMenuItems } = useContext(TitleContext);
  return { menuItems, setMenuItems };
}
